import { render, staticRenderFns } from "./tCalendar.vue?vue&type=template&id=4f8cf55e&scoped=true"
import script from "./tCalendar.vue?vue&type=script&lang=js"
export * from "./tCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8cf55e",
  null
  
)

export default component.exports